/**
 * The company edit lock's resource type (#398 C11), the same string the server's jobs lock under
 * (`CompanyLock.ResourceType`, AGWA.Auth/Locking/CompanyLock.cs). The resource id is the company's
 * LoginGroup id. A company's own details and its Block / Unblock take it; its sites, people and
 * module tabs are their own records and do not.
 */
export const COMPANY_LOCK_RESOURCE = 'Company';
